// src/components/BlogCard.jsx
import { Link } from "react-router-dom";

const BlogCard = ({ post }) => (
  <div className="bg-white shadow p-4 rounded-xl hover:shadow-lg transition my-10">
    <h2 className="text-2xl font-semibold mb-2">{post.title}</h2>
    <p>{post.desc}</p>
    <Link to={`/blogs/${post.id}`} className="text-blue-600 hover:underline">
      Read More →
    </Link>
  </div>
);

export default BlogCard;
